module.exports = __webpack_public_path__ + "18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/18.png
// module id = 533
// module chunks = 0